import { createRouter, createWebHistory } from "vue-router";
// Parametros
import ParametrosGlobales from "../views/Sistema/ParametrosGlobales/ParametrosGlobales.vue";
import Autenticacion from "../views/Sistema/Autenticacion/Autenticacion.vue";
import Perfiles from "../views/Sistema/Perfil/Perfil.vue";
import ViewGeneral from "../views/components/VistaGeneral/VistaGeneral.vue";
import Advertencias from "../views/components/Advertencias/404.vue";
import Inicio from "../views/components/VistaGeneral/Inicio.vue";
// Procesos
import BandejaEntrada from "../views/TCI/ProcesosO/AutomatizacionProcesos/BandejaEntrada.vue";
import ConstruccionPagina from "../views/TCI/ProcesosO/AutomatizacionProcesos/ConstruccionPagina.vue";
import ConsultaSolicitudes from "../views/TCI/ProcesosO/ConsultaSolicitudes/ConsultaSolicitudes.vue";
import CambioProceso from "../views/TCI/ProcesosO/CambioProceso/CambioProceso.vue";
import ReasignacionManual from "../views/TCI/ProcesosO/ReasignacionManual/ReasignacionManual.vue";
import MigracionRadicador from "../views/TCI/ProcesosO/MigracionRadicador/MigracionRadicador.vue";
import Lineas from "../views/TCI/ProcesosP/Lineas/Lineas.vue";
import Procesos from "../views/TCI/ProcesosP/Procesos/Proceso.vue";
import RelacionLineaCreditoProceso from "../views/TCI/ProcesosP/RelacionLineaCreditoProceso/RelacionLineaCreditoProceso.vue";
import RelacionProcesoDato from "../views/TCI/ProcesosP/RelacionProcesoDato/RelacionProcesoDato.vue";
import Datos from "../views/TCI/ProcesosP/Datos/Datos.vue";
import DatoCalculado from "../views/TCI/ProcesosP/DatoCalculado/DatoCalculado.vue";
import ValorNumerico from "../views/TCI/ProcesosP/ValoracionNumerica/ValoracionNumerica.vue";
import ValorAlfaNumerico from "../views/TCI/ProcesosP/ValoracionAlfaNumerica/ValoracionAlfaNumerica.vue";
//Activos
import TableroControlActivos from "../views/TCI/Tablero/TableroControlActivos/TableroControlActivos.vue";
import TableroControlGarantias from "../views/TCI/Tablero/TableroControlGarantias/TableroControlGarantias.vue";
import Activos from "../views/TCI/ActivosO/Activos/Activos.vue";
import Contratos from "../views/TCI/ActivosO/Contratos/Contratos.vue";
// Personas
import Personas from "../views/TCI/Personas/Clientes/Clientes.vue";
import MigracionTrazabilidad from "../views/TCI/Personas/MigracionTrazabilidad/MigracionTrazabilidad.vue";
import SubidaLLamadas from "../views/TCI/Personas/MigracionTrazabilidad/SubidaLlamadas/SubidaLlamadas.vue";
//Reportes
import Reportes from "../views/TCI/Reportes/DescargarReportes/Reportes.vue";
import Consultaformulario from "../views/TCI/Formularios/ConsultaFormularios/ConsultaFormularios.vue";
import ConsultaFormulariosHistorico from "../views/TCI/Formularios/ConsultaFormulariosHistorico/ConsultaFormulariosHistorico.vue";
//Formulario Dinámico
import FormularioDinamico from "../views/TCI/Formularios/FormularioDinamico/FormularioDinamico.vue";
// Migraciones
import MigracionActivosExternosProcesos from "../views/TCI/Migraciones/ActivosExternosProcesos/MigracionActivosExternosProcesos.vue";
import MigracionGarantias from "../views/TCI/Migraciones/MigracionGarantias/MigracionGarantias.vue";
import MigracionActivos from "../views/TCI/Migraciones/MigracionActivos/MigracionActivos.vue";
import ActualizacionCubo from "../views/TCI/Migraciones/MigracionActivos/MigracionCubo/MigracionCubo.vue";
import ActualizacionTipoServicio from "../views/TCI/Migraciones/MigracionActivos/MigracionTipoServicio/MigracionTipoServicio.vue";
import ActualizacionLocacion from "../views/TCI/Migraciones/MigracionActivos/MigracionLocacion/MigracionLocacion.vue";
import MigracionActivos2 from "../views/TCI/Migraciones/MigracionActivos/MigracionActivosDos.vue";
import MigracionActivosBRP from "../views/TCI/Migraciones/MigracionActivos/MigracionBRP/MigracionActivosBRP.vue";
// Seguridad
import Usuarios from "../views/TCI/Seguridad/Usuarios/Usuarios.vue";
import Roles from "../views/TCI/Seguridad/Roles/Roles.vue";
import Links from "../views/TCI/Seguridad/Links/Links.vue";
import RelacionUsuarioPerfil from "../views/TCI/Seguridad/RelacionUsuarioPerfil/RelacionUsuarioPerfil.vue";
import RelacionOpcionPerfil from "../views/TCI/Seguridad/RelacionOpcionPerfil/RelacionOpcionPerfil.vue";
// Parametros
import Plantilla from "../views/TCI/Parametros/Plantillas/Plantilla.vue";
import Notificaciones from "../views/TCI/Parametros/Notificaciones/Notificaciones.vue";
import DisparadorNotificaciones from "../views/TCI/Parametros/DisparadorNotificaciones/DisparadorNotificaciones.vue";
// Documentos
import Documentos from "../views/TCI/Documentos/Documentos/Documentos.vue";
const routes = [
  {
    path: "/:catchAll()",
    redirect: "/404",
  },
  {
    path: "/",
    name: "Inicio Sesión",
    component: Autenticacion,
  },
  {
    path: "/perfiles",
    name: "Perfiles",
    component: Perfiles,
  },
  {
    path: "/inicio",
    name: "Inicio",
    component: ViewGeneral,
    children: [
      {
        path: "/404",
        name: "404",
        meta: { private: true, title: "404 Página no encontrada" },
        component: Advertencias,
      },
      {
        path: "/tci",
        name: "Inicio",
        meta: { private: true, title: "Inicio" },
        component: Inicio,
      },
      {
        path: "/parametrosglobales/:id",
        name: "Parametros Globales",
        meta: { private: true, title: "Parametros Globales" },
        component: ParametrosGlobales,
      },
      {
        path: "/procesoso/automatizacionprocesos/:id",
        name: "Bandeja de entrada",
        meta: { private: true, title: "Bandeja Entrada" },
        component: BandejaEntrada,
      },
      {
        path: "/proceso/:id",
        name: "Captura Inicial",
        meta: { private: true, title: "Captura Inicial" },
        component: ConstruccionPagina,
      },
      {
        path: "/proceso/consultasolicitudes/:id",
        name: "Consulta Solicitudes",
        meta: { private: true, title: "Consulta Solicitudes" },
        component: ConsultaSolicitudes,
      },
      {
        path: "/proceso/consultasolicitudesasignada/:id",
        name: "Consulta Solicitudes Asignadas",
        meta: { private: true, title: "Consulta Solicitudes Asignadas" },
        component: ConsultaSolicitudes,
      },
      {
        path: "/proceso/cambioproceso/:id",
        name: "Cambio Proceso",
        meta: { private: true, title: "Cambio Proceso" },
        component: CambioProceso,
      },
      {
        path: "/proceso/eliminarsolicitud/:id",
        name: "Eliminar Solicitud",
        meta: { private: true, title: "Eliminar Solicitud" },
        component: CambioProceso,
      },
      {
        path: "/proceso/reasignacionmanual/:id",
        name: "Reasignación Manual",
        meta: { private: true, title: "Reasignación Manual" },
        component: ReasignacionManual,
      },
      {
        path: "/proceso/migracionradicador/:id",
        name: "Migración Radicador",
        meta: { private: true, title: "Migración Radicador" },
        component: MigracionRadicador,
      },
      {
        path: "/activos/tablerocontrolactivos/:id",
        name: "Tablero Control Activos",
        meta: { private: true, title: "Tablero de Control de Activos" },
        component: TableroControlActivos,
      },
      {
        path: "/activos/tablerocontrolgarantias/:id",
        name: "Tablero Control Garantías",
        meta: { private: true, title: "Tablero de Control de Garantías" },
        component: TableroControlGarantias,
      },
      {
        path: "/activoso/activos/:id",
        name: "Activos",
        meta: { private: true, title: "Activos" },
        component: Activos,
      },
      {
        path: "/activoso/contratos/:id",
        name: "Contratos",
        meta: { private: true, title: "Contratos" },
        component: Contratos,
      },
      {
        path: "/personas/clientes/:id",
        name: "Clientes",
        meta: { private: true, title: "Clientes" },
        component: Personas,
      },
      {
        path: "/activoso/migraciongarantias/:id",
        name: "Migración Garantías",
        meta: { private: true, title: "Migración Garantías" },
        component: MigracionGarantias,
      },
      {
        path: "/activoso/migracionactivos/:id",
        name: "Migración Activos",
        meta: { private: true, title: "Migración Activos" },
        component: MigracionActivos,
      },
      {
        path: "/activoso/migracionactivosdos/:id",
        name: "Migración Información Activos",
        meta: { private: true, title: "Migración Información Activos" },
        component: MigracionActivos2,
      },
      {
        path: "/activoso/migracionactivosbrp/:id",
        name: "Migración Información Activos BRP",
        meta: { private: true, title: "Migración Información Activos BRP" },
        component: MigracionActivosBRP,
      },
      {
        path: "/activoso/migracioncubo/:id",
        name: "Actualización Cubo",
        meta: { private: true, title: "Actualización Cubo" },
        component: ActualizacionCubo,
      },
      {
        path: "/activoso/migraciontiposervicio/:id",
        name: "Actualización Tipo de Servicio",
        meta: { private: true, title: "Actualización Tipo de Servicio" },
        component: ActualizacionTipoServicio,
      },
      {
        path: "/activoso/migracionlocacion/:id",
        name: "Actualización Ubicación",
        meta: { private: true, title: "Actualización Ubicación" },
        component: ActualizacionLocacion,
      },
      {
        path: "/reportes/descargar/:id",
        name: "Reportes",
        meta: { private: true, title: "Reportes" },
        component: Reportes,
      },
      {
        path: "/formulario/consultaformulario/:id",
        name: "Consultar Formulario",
        meta: { private: true, title: "Consultar Formulario" },
        component: Consultaformulario,
      },
      {
        path: "/formularios/formulariodinamico/:id",
        name: "Formularios",
        meta: { private: true, title: "Formularios" },
        component: FormularioDinamico,
      },
      {
        path: "/formulario/consultaformulariohistorico/:id",
        name: "Consultar Formulario Histórico",
        meta: { private: true, title: "Consultar Formulario Histórico" },
        component: ConsultaFormulariosHistorico,
      },
      {
        path: "/personas/masivotrazabilidad/:id",
        name: "Masivo Trazabilidad",
        meta: { private: true, title: "Masivo Trazabilidad" },
        component: MigracionTrazabilidad,
      },
      {
        path: "/personas/subidaLlamadas/:id",
        name: "Subida de Llamadas Masivo",
        meta: { private: true, title: "Subida de Llamadas Masivo" },
        component: SubidaLLamadas,
      },
      {
        path: "/procesosp/lineas/:id",
        name: "Lineas",
        meta: { private: true, title: "Lineas" },
        component: Lineas,
      },
      {
        path: "/procesosp/procesos/:id",
        name: "Procesos",
        meta: { private: true, title: "Procesos" },
        component: Procesos,
      },
      {
        path: "/procesosp/relacionlineacreditoproceso/:id",
        name: "RelacionLineaCreditoProceso",
        meta: { private: true, title: "Relación Linea - Proceso" },
        component: RelacionLineaCreditoProceso,
      },
      {
        path: "/procesosp/relacionprocesodato/:id",
        name: "RelacionProcesoDato",
        meta: { private: true, title: "Relación Proceso - Dato" },
        component: RelacionProcesoDato,
      },
      {
        path: "/procesosp/datos/:id",
        name: "Datos",
        meta: { private: true, title: "Datos" },
        component: Datos,
      },
      {
        path: "/procesosp/datoscalculados/:id",
        name: "DatosCalculados",
        meta: { private: true, title: "Datos Calculados" },
        component: DatoCalculado,
      },
      {
        path: "/procesosp/valornumerico/:id",
        name: "ValoracionNumerica",
        meta: { private: true, title: "Valoración Numérica" },
        component: ValorNumerico,
      },
      {
        path: "/procesosp/valoralfanumerico/:id",
        name: "ValoracionAlfaNumerica",
        meta: { private: true, title: "Valoración Alfanumérica" },
        component: ValorAlfaNumerico,
      },
      {
        path: "/activoso/migracionactivosprocesos/:id",
        name: "Actualización Activos Procesos",
        meta: { private: true, title: "Actualización Activos Procesos" },
        component: MigracionActivosExternosProcesos,
      },
      {
        path: "/seguridad/usuarios/:id",
        name: "Usuarios",
        meta: { private: true, title: "Usuarios" },
        component: Usuarios,
      },
      {
        path: "/seguridad/links/:id",
        name: "Links",
        meta: { private: true, title: "Links" },
        component: Links,
      },
      {
        path: "/seguridad/roles/:id",
        name: "Roles",
        meta: { private: true, title: "Roles" },
        component: Roles,
      },
      {
        path: "/seguridad/relacionusuarioperfil/:id",
        name: "RelacionUsuarioPerfil",
        meta: { private: true, title: "Relación Usuario Perfil" },
        component: RelacionUsuarioPerfil,
      },
      {
        path: "/seguridad/relacionopcionperfil/:id",
        name: "RelacionOpcionPerfil",
        meta: { private: true, title: "Relación Opción Perfil" },
        component: RelacionOpcionPerfil,
      },
      {
        path: "/parametros/plantillas/:id",
        name: "Plantillas",
        meta: { private: true, title: "Plantillas" },
        component: Plantilla,
      },
      {
        path: "/parametros/notificaciones/:id",
        name: "Notificaciones",
        meta: { private: true, title: "Notificaciones" },
        component: Notificaciones,
      },
      {
        path: "/parametros/disparadornotificaciones/:id",
        name: "DisparadorNotificaciones",
        meta: { private: true, title: "Disparador Notificaciones" },
        component: DisparadorNotificaciones,
      },
      {
        path: "/documentos/:id",
        name: "Documentos",
        meta: { private: true, title: "Documentos" },
        component: Documentos,
      }
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from) => {
  const infoToken = localStorage.getItem("token");
  if (to.name === "Inicio Sesión") {
    localStorage.removeItem("token");
    localStorage.removeItem("infoperfil");
    localStorage.removeItem("registromenu");
    localStorage.removeItem("paginainfo");
  } else if (
    (infoToken == null || infoToken == "") &&
    to.name !== "Inicio Sesión"
  ) {
    // redirect the user to the login page
    return { name: "Inicio Sesión" };
  }
});

export default router;
